import React from 'react';
import { IImage, IMedia } from "types/base";
import { Image } from "react-datocms";
import Link from "components/base/Link";
import Author from "components/blog/Author";
import MetaData from "components/blog/MetaData";
import Text from "components/typography/Text";

export type IAuthor = {
    name: string;
    company?: string;
    function?: string;
    image?: IImage;
};

export type IBlogCategory = {
    name: string;
};


export type IBlogPost = {
    id: string,
    title: string,
    slug: string,
    featuredImage: IImage,
    author: IAuthor,
    categories: IBlogCategory[],
    readTime: number,
    intro: any,
    content: {
        value: any,
        blocks: IMedia[]
    },
    relatedBlogPosts?: IBlogPost[],
    type: string,
};

export default function RelatedCard(props: IBlogPost) {
    const { featuredImage, categories, title, slug, author, readTime, type } = props;

    return (
        <div className={'h-full flex flex-col'}>
            <Link to={`/${type}/${slug}`} className={"group flex grow"}>
                <div className={"flex flex-col h-full lg:overflow-hidden"}>
                    <div className={"mb-6 flex-1 lg:w-full lg:overflow-hidden"}>
                        {featuredImage ? (
                            <div className={"group-hover:scale-105 transform transition-transform duration-700"}>
                                <Image
                                    data={featuredImage.responsiveImage}
                                    pictureClassName={"object-contain lg:w-full lg:h-full"}
                                />
                            </div>
                        ) : (
                            <img
                                alt={"Featured Image"}
                                src={"https://www.tekstmaatje.nl/wp-content/uploads/2020/06/placeholder.png"}
                                className={"h-28 object-cover lg:w-full lg:object-scale-down lg:h-full"}
                            />
                        )}
                    </div>
                    <div className={"flex flex-col w-4/5 overflow-clip"}>
                        <MetaData categories={categories} readTime={readTime}/>
                        <Text size={'xl'} color={'text-gray-900'} weight={'semibold'} className={'pt-3'}>
                            {title}
                        </Text>
                        <div className={"pt-16 lg:pt-15"}>
                            <Author {...author} avatarSize={"small"}/>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}